var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('event-detail-mobile'):_c('event-detail-dekstop')
}
var staticRenderFns = []

export { render, staticRenderFns }